var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass: "push-notification-popup",
            class:
              ((_obj = {}),
              (_obj["push-notification-popup--" + _vm.color] = _vm.color),
              _obj),
          },
          [
            _c("div", { staticClass: "close-icon" }, [
              _c("div", {
                staticClass: "common__icon",
                class: _vm.closeIconClass,
                on: { click: _vm.onCloseClick },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "push-notification-popup__icon" },
              [_vm._t("icon")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "push-notification-popup__content",
                on: {
                  click: function ($event) {
                    return _vm.redirect()
                  },
                },
              },
              [
                _c("h5", [_vm._t("title")], 2),
                _vm._v(" "),
                _c("p", [_vm._t("content")], 2),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "link", on: { click: _vm.onCloseClick } },
                  [_vm._t("link")],
                  2
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }